module.exports = __webpack_public_path__ + "img/web-about-historia.c58663ac.png";